import { fetchJS, services } from '@/utilities/general'
import { base_url, onboarding } from '@/utilities/urls'
import Swal from 'sweetalert2';

export default {
    install(app) {
        app.config.globalProperties.$base_url = base_url;
        app.config.globalProperties.$onboarding = onboarding;
        app.config.globalProperties.$fetchJS = fetchJS;
        app.config.globalProperties.$services = services;

        app.config.globalProperties.$validateForm = (inputData, inputs, is_number = false, is_required = true) => {
            const msgError = {}
            const required = is_required ? ' es requerido' : ''

            for (let val in inputData) {
                const value = inputs[val]
                if (value === '' || value === null || (is_number && value <= 0)) {
                    msgError[val] = `${inputData[val]}${required}`
                }
            }
            return msgError;
        }

        app.config.globalProperties.$showErrors = (msgError, dataInput = '.form-input') => {
            const inputsAll = document.querySelectorAll(`${dataInput} [name]`)
            const valueInputs = []

            inputsAll.forEach(item => valueInputs.push(item.name));
            
            for (const property in msgError) {
                let exist = valueInputs.find((item) => item === property);
                if (exist) {
                    let error = document.querySelector(`${dataInput} [data-error="${property}"]`)
                    error.classList.add('show');
                    error.innerText = msgError[property]

                }
            }
        }

        app.config.globalProperties.$removeErrors = (dataInput = '.form-input') => {
            let errorTAg = document.querySelectorAll(`${dataInput} [data-error]`);
            errorTAg.forEach(element => element.classList.remove('show'));
        }

        app.config.globalProperties.$getTokenNubarium = async () => {
            const response = await fetchJS({
                url: services.nubarium_token(),
                redirect: "follow",
                method: 'POST',
                body: {
                    'api_key' : app.config.globalProperties.$vars()['api_key']
                }
            }, false);
            if (response.status != 200) {
                app.config.globalProperties.$loadingClose();
                app.config.globalProperties.$alert({ type: 'error', text: 'Error al recuperar token'})
                return false;
            }
            const json = JSON.parse(atob(response.data.data));
            return json.token;
        };


        /**
         * Muestra o oculta la ventana modal
         * @param {Object} param0 
         * @returns 
         */
        app.config.globalProperties.$modal = ({ id = '', isShow = true }) => {
            const modal = document.querySelector(`#${id}`)
            if (!modal) {
                return
            }

            if (isShow) {
                modal.style.display = 'flex';
                setTimeout(() => {
                    modal.classList.add('show');
                }, 10);
                return
            }

            modal.classList.remove('show');
            setTimeout(() => {
                modal.style.display = 'none';
            }, 300);

            // isShow ? modal.classList.add('show') : modal.classList.remove('show')
        }
        /**
         * 
         * @param {Object} param0 
         * @returns 
         */
        app.config.globalProperties.$loading = ({ isShow = true, classLoad = 'load-info', text = 'Validando' }) => {
            const loader = document.querySelector('#loader'),
            body = document.querySelector('body')
            
            if (!isShow) {
                loader.classList.remove("show");
                loader.classList.remove("load-info");
                loader.classList.remove("load-page");
                loader.removeAttribute('data-text');
                // loader.querySelector('.text-load').dataset.text = '';
                body.removeAttribute('style')
                return
            }
            
            if (loader && isShow) {
                body.style.overflow = 'hidden';
                loader.classList.add(`${classLoad}`)
                loader.classList.add("show");
                // loader.setAttribute('data-text', text);
                loader.querySelector('.text-load').dataset.text = text;
            }
        };
        app.config.globalProperties.$loadingClose = () => {
            const loader = document.querySelector('#loader');
            if (!loader) {
                return;
            }
            app.config.globalProperties.$loading({ isShow: false });
        }
        app.config.globalProperties.$loadElements = ({element = '#load-elements', isShow = true}) => {
            const loader = document.querySelector(`${element} div`)

            // load-elements
            if (!loader) {
                return
            }
            const tableScroll = loader.closest('.table-scroll')
            if (isShow) {
                loader.classList.add('show')
                tableScroll.classList.add('hide-scroll')
                return
            }
            
            tableScroll.classList.remove('hide-scroll')
            loader.classList.remove('show')
        }
        app.config.globalProperties.$formatDate = date => {
            if (!date) {
                return '';
            }
            const d = new Date(date),
                year = d.getFullYear();

            let month = '' + (d.getMonth() + 1),
                day = '' + d.getDate();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        }
        app.config.globalProperties.$formatHour = date => {
            const d = new Date(date);
            let hour = '' + d.getHours(),
                minute = '' + d.getMinutes(),
                second = '' + d.getSeconds();

            if (hour.length < 2) hour = '0' + hour;
            if (minute.length < 2) minute = '0' + minute;
            if (second.length < 2) second = '0' + second;

            return [hour, minute, second].join(':');
        }
        app.config.globalProperties.$redondear = (cantidad, decimales = 3) => {
            cantidad = +cantidad || 0
            return cantidad.toFixed(decimales);
        }
        app.config.globalProperties.$formatoNumero = (numero, decimales = 3) => {
            numero = app.config.globalProperties.$redondear(numero, decimales)
            numero += '';
            const exp = /(\d)(?=(\d{3})+(?!\d))/g;
            const rep = '$1,';
            let arr = numero.toString().split('.');
            arr[0] = arr[0].replace(exp,rep);
            return arr[1] ? arr.join('.'): arr[0];
        }

        app.config.globalProperties.$validarCorreo = correo => {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(correo);
        }

        app.config.globalProperties.$formatCurrency = value => {
            return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
        },

        /**
         * Muestra un mensaje de alerta
         * @param {Object} param0 
         * @returns 
         */
        app.config.globalProperties.$alert = ({type = 'success', text = '', title = '',  html = false}) => {

            const data = {
                'success' : {
                    icon : 'success',
                    confirmButtonText : 'Aceptar',
                    confirmButton : 'button success w-7'
                },
                'error' : {
                    icon : 'error',
                    confirmButtonText : 'Aceptar',
                    confirmButton : 'button danger w-7'
                },
                'warning' : {
                    icon : 'warning',
                    confirmButtonText : 'Aceptar',
                    confirmButton : 'button warning w-7'
                },
                'info' : {
                    icon : 'info',
                    confirmButtonText : 'Aceptar',
                    confirmButton : 'button info w-7'
                }
            }

            const alert = {
                icon:  data[type].icon,
                title: title,
                text: text,
                confirmButtonText: data[type].confirmButtonText,
                customClass: {
                    confirmButton: data[type].confirmButton
                },
                buttonsStyling: false
            }
            

            html && (alert['html'] = html)

            return Swal.fire(alert);
        },

        /**
         * Cambia las llaves de nombre en un arreglo de objetos
         * @param {Array} array Arreglo con valores
         * @returns 
         */
        app.config.globalProperties.$changeKeys = (array, idKey = 'id', textKey = 'descripcion') => {
            return array.map(item => ({
                value: item[idKey],
                text: item[textKey]
            }));
        };

        app.config.globalProperties.$request = async (url, method = 'GET', body = null) => {
            const response = await fetchJS({
                url: url,
                redirect: "follow",
                method: method,
                body: body
            });
            return response
        } 
    }
}